'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { pushDataLayerEvent } from '@/shared/libs/analytics/gtm';

export default function GtmPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const handlePageView = () => {
      const query = searchParams.toString();
      const url = query ? `${pathname}?${query}` : pathname;

      pushDataLayerEvent({
        event: 'page_view',
        page_path: url,
        page_location: window.location.href,
        page_title: document.title,
      });
    };

    handlePageView();
  }, [pathname, searchParams]);

  return null;
}
